<!--suppress ALL -->
<template>
  <v-app class="ma-0 pa-0">
    <v-progress-linear v-if="$store.state.loading.loading" indeterminate/>
    <v-main>
      <AppBanner :model="incompleteProfile" isProfileBanner :user="user" :max-width="bannerWidth"/>
      <AppBanner :model="showWebinnarReminder" isWebinarBanner max-width="99%" color="#0033AA" />
      <SnackBar/>
      <signInDialog :dialog="authDialog"/>
      <router-view :key="$route.fullPath" v-if="!authLoading"/>
      <v-container v-else fill-height>
        <v-layout align-center justify-center row>
          <v-progress-circular :size="200" indeterminate>
            <v-img :src="logo" width="150"/>
          </v-progress-circular>
        </v-layout>
      </v-container>
       <v-btn
            v-scroll="onScroll"
            v-show="fab"
            fab
            dark
            fixed
            bottom
            right
            color="primary"
            @click="toTop"
          >
            <v-icon color="white" size="40">mdi-chevron-up</v-icon>
          </v-btn>
    </v-main>
  </v-app>
</template>

<script>
import SnackBar from "./components/snack-bar";
import signInDialog from "./components/signInDialog";
import {mapGetters, mapMutations} from "vuex";
import logo from "./assets/logo.jpg";
import {loadLanguageAsync} from "./plugins/i18n";
import firebase from "firebase/app";
import 'firebase/firestore';
import AppBanner from "@/components/AppBanner";

export default {
  name: "App",
  components: {
    AppBanner,
    SnackBar,
    signInDialog
  },
  data: () => ({
    logo,
    fab: false
  }),
  metaInfo: {
    changed(metaInfo) {
      firebase.analytics().logEvent("page_view");
      firebase.analytics().logEvent("screen_view", {
        screen_name: metaInfo.title || "screen view",
        user: this.user || "no user logged in",
        time: new Date(),
        url: metaInfo.url || window.location.href,
        version: "frontend version"
      });
    }
  },
  mounted() {
    this.$analytics.logEvent("page_view");
  },
  async created() {
    const selectedLang = localStorage.getItem("language")
    loadLanguageAsync(selectedLang || "en");
    const token = localStorage.getItem('access_token');
    if (token) {
      try {
        const {data: {user}} = await this.axios.get('users/me');
        this.setAuthSuccess(user);
        this.setUserProfile(user.profile);
      } catch (e) {
        if(e.response?.status === 401) {
          localStorage.removeItem("access_token");
          this.logout();
        }
      }
    } else {
      localStorage.removeItem("access_token");
      this.logout();
    }
  },
  methods: {
    ...mapMutations({
      setAuthSuccess: "auth/SET_AUTH_SUCCESS",
      setAuthLoading: "auth/SET_AUTH_LOADING",
      setUserProfile: "auth/SET_USER_PROFILE",
      setLoading: "loading/SET_LOADING",
      logout: "auth/SET_AUTH_LOGOUT"
    }),
     onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset ||   e.target.scrollTop || 0
      this.fab = top > 20
    },
     toTop () {
      this.$vuetify.goTo(0)
    }
  },
  computed: {
    ...mapGetters({
      authLoading: "auth/GET_AUTH_LOADING",
      authDialog: "auth/GET_AUTH_DIALOG",
      user: "auth/GET_USER",
      profile: "auth/GET_USER_PROFILE",
      isAuthenticated: "auth/GET_IS_AUTHENTICATED",
    }),
    isMentor() {
      return this.user.account_types?.filter((item) => item.name === "MENTOR").length;
    },
    showWebinnarReminder() {
      const webinarDate = new Date('2022-09-10')
      return (webinarDate.toDateString() !==  new Date().toLocaleDateString()) && (webinarDate > new Date()) && this.$route.path === '/'
    },
    bannerWidth() {
      if(this.$vuetify.breakpoint.xs) return '100%';
      if(this.$route.fullPath.indexOf('blogs') !== -1) return '85%'
      if(this.$route.name === 'home-blogs') return '85%'
      else return '100%'
    },
    incompleteProfile: {
      get: function() {
        if(!this.isAuthenticated) return false
        else if(this.$route.path === '/') return false
        else if(this.$route.name === 'blogs-show') return false
        else if(this.$route.name === 'create-blog') return false
        else if(this.$route.name === 'edit-blog') return false
        else if(this.$route.name === 'Not-Found-Page') return false
        else if(this.$route.path === "/profile") return false
        else if(this.$route.path === "/privacy-policy") return false
        else if(this.$route.path === "/blog-guidelines") return false
        else if(this.$route.path === "/terms-of-use") return false
        else {
          if(this.profile) {
            const {first_name, last_name, country, biography, avatar} = this.profile
            if(!first_name && !last_name) return true
            if(!country) return true
            if(!avatar) return true
            if(!biography) return true
            if(this.isMentor && !this.profile.grade_level) return true
            if(this.isMentor && !this.profile.subjects.length) return true
            else return false
          }
          else return true
        }
      },
      set: function (value) {
        return value
      }
    }
  },
};
</script>

<style>
#app {
  font-family: Montserrat, Avenir, Helvetica, Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #f5f6f8;
}
</style>
